import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=39b4db9c&scoped=true&"
import script from "./page7.vue?vue&type=script&lang=js&"
export * from "./page7.vue?vue&type=script&lang=js&"
import style0 from "./page7.vue?vue&type=style&index=0&id=39b4db9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b4db9c",
  null
  
)

export default component.exports